import SidebarContent from './SidebarContent.container';

export default SidebarContent;
